import collaborationStore from '@/store/collaboration.store';
import { SocketClient } from '@core/ability';
import AsrHandler from '../AsrHandler';
import { IChapterList, IKeyframeItem } from '@/types/summary';

class CollaborationHandler {
  private static _socketClient = new SocketClient();
  constructor() {
    throw new Error('CollaborationHandler is a static class');
  }
  public static initSocket = (streamName: string, wssPushUrl: string) => {
    CollaborationHandler._socketClient.start(streamName, wssPushUrl);
    CollaborationHandler._onMessage();
    CollaborationHandler._onEnd();
  };

  public static stopSocket = async () => {
    CollaborationHandler._socketClient.stop();
    CollaborationHandler._socketClient.removeAllListeners();
  };

  public static getReadyState = async () => {
    const readyState = await CollaborationHandler._socketClient.getReadyState();
    return readyState;
  };

  private static _onMessage() {
    CollaborationHandler._socketClient.removeAllListeners();
    CollaborationHandler._socketClient.on('message', (message) => {
      switch (message.status) {
        case 'unstable':
        case 'stable':
        case 'completeWithSpeakerName':
        case 'correct':
        case 'transcriptionSupplement':
        case 'transcriptionUpdateTrans':
        case 'personalModifyRole':
          AsrHandler.handleAsr(message, true);
          break;
        case 'smartChapter':
          CollaborationHandler.handleSmartChapter(message);
          break;
        case 'smartChapterKeyframe':
          CollaborationHandler.handleSmartChapterKeyframe(message);
          break;
        default:
          break;
      }
    });
  }

  private static _onEnd() {
    CollaborationHandler._socketClient.on('end', () => {
      collaborationStore.getState().setMeetingFinish(true);
    });
  }

  private static handleSmartChapter = (message: any) => {
    const _chapterSummary = collaborationStore.getState().chapterSummary;
    const newChapterSummary: IChapterList[] = [];
    message.texts.body.forEach((item: IChapterList) => {
      if (_chapterSummary.findIndex((i) => i.topic === item.topic) === -1) {
        newChapterSummary.push(item);
      }
    });
    collaborationStore.getState().setChapterSummary([..._chapterSummary, ...newChapterSummary]);
  };

  private static handleSmartChapterKeyframe = (message: any) => {
    const _chapterKeyframe = collaborationStore.getState().keyframeArr;
    const newChapterKeyframe: IKeyframeItem[] = [];
    message.texts.body.forEach((item: IKeyframeItem) => {
      if (!_chapterKeyframe.find(existedItem => existedItem.keyFrameFilekey === item.keyFrameFilekey)) {
        newChapterKeyframe.push(item);
      }
    });
    collaborationStore.getState().setChapterKeyframe([..._chapterKeyframe, ...newChapterKeyframe]);
  };
}

export default CollaborationHandler;
